import clsx from 'clsx';
import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

type NavItemProps = {
  to: string;
  icon: ReactNode;
  label: string;
  isContactOpen?: boolean;
  closeNavigation: () => void;
  className?: string;
};
type NavItemContentProps = {
  icon: ReactNode;
  label: string;
};

export const NavItemContent = ({ icon, label }: NavItemContentProps) => {
  return (
    <p className="flex items-center w-full py-2 px-1">
      {icon}
      <span>{label}</span>
    </p>
  );
};
export const NavItem = ({ to, icon, label, isContactOpen, closeNavigation, className }: NavItemProps) => {
  return (
    <li className={clsx(className, 'border-b')}>
      <NavLink
        onClick={closeNavigation}
        to={to}
        className={({ isActive }) =>
          clsx('w-full py-4 px-2 inline-block', isActive && !isContactOpen && 'bg-background')
        }
      >
        <NavItemContent icon={icon} label={label} />
      </NavLink>
    </li>
  );
};
